import api from '../token';

export const AddCliente = async (dados) => {
  try {
    const response = await api.post('/addCliente', dados);
    return response.data;
  } catch (error) {
    
    return { success: false, message: error.message };
  }
};